import { graphql } from 'react-relay';

export const abstractBlockFragment = graphql`
    fragment AbstractBlock_contentBlock on AbstractBlock {
        text
    }
`;
